import { render, staticRenderFns } from "./save-share-pic.vue?vue&type=template&id=45ef57ce&scoped=true&"
import script from "./save-share-pic.vue?vue&type=script&lang=js&"
export * from "./save-share-pic.vue?vue&type=script&lang=js&"
import style0 from "./save-share-pic.vue?vue&type=style&index=0&id=45ef57ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ef57ce",
  null
  
)

export default component.exports